import { Tooltip, Typography } from '@mui/material'
import moment from 'moment'
import { HumanDate, ConditionallyRender } from 'components'
import { FormattedMessage } from 'react-intl'
import intl from 'localization/components'
import { getLastActivity, isApiOnlyRow, LastActivityRow } from './last-activity'

interface LastLoginViewProps {
  props: LastActivityRow
}

const textSx = { fontSize: 14 }

const LastLoginView = ({ props }: LastLoginViewProps) => {
  const lastActivity = getLastActivity(props)

  if (!lastActivity) {
    // ENG2-2411: an API token that has never authenticated a request
    if (isApiOnlyRow(props)) {
      return (
        <Typography sx={textSx} data-testid="last-activity-never-used">
          <FormattedMessage id={intl.userManagement('never-used')} />
        </Typography>
      )
    }
    if (!props.userData) return <Typography sx={textSx}>-</Typography>
    return (
      <Typography sx={textSx}>
        <FormattedMessage id={intl.userManagement('no-data-yet')} />
      </Typography>
    )
  }

  const activity = moment(lastActivity)
  const daysSinceActivity = moment().diff(activity, 'days')

  return (
    <Tooltip title={activity.format('DD.MM.YYYY HH:mm')} placement="top">
      <span data-testid="last-activity">
        <ConditionallyRender
          condition={daysSinceActivity < 30}
          when={
            <HumanDate
              style={{ color: 'orange', fontSize: 14 }}
              date={activity}
            />
          }
          otherwise={
            <Typography sx={textSx}>
              <FormattedMessage id={intl.userManagement('more-than-30')} />
            </Typography>
          }
        />
      </span>
    </Tooltip>
  )
}

export default LastLoginView
